import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import { Icon, Switch } from "@mui/material";
import PropTypes from "prop-types";
import SoftButton from "components/SoftButton";
import SoftAvatar from "components/SoftAvatar";

function Title({ title, subTitle, image }) {
    return (
        <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
            <SoftBox mr={2}>
                <SoftAvatar src={image} alt={title} size="sm" variant="rounded" />
            </SoftBox>
            <SoftBox display="flex" flexDirection="column">
                <SoftTypography variant="button" fontWeight="medium">
                    {title}
                </SoftTypography>
                <SoftTypography variant="caption" color="secondary">
                    {subTitle}
                </SoftTypography>
            </SoftBox>
        </SoftBox>
    );
}
Title.defaultProps = {
    title: "",
    image: "",
    subTitle: "",
};
Title.propTypes = {
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
};

function Slug({ job }) {
    return (
        <SoftBox display="flex" flexDirection="column">
            <SoftTypography variant="caption" fontWeight="medium" color="text">
                {job}
            </SoftTypography>
        </SoftBox>
    );
}
Slug.defaultProps = {
    job: "",
};
Slug.propTypes = {
    job: PropTypes.string.isRequired,
};

function Actions({ currentBlogData, handleEditItem, handleDeleteItem }) {
    return <>
        <SoftButton variant="gradient" color="info" iconOnly={true} onClick={() => handleEditItem(currentBlogData)}>
            <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" onClick={() => handleEditItem(currentBlogData)}>
                create
            </Icon>
        </SoftButton>
        &nbsp;
        <SoftButton variant="gradient" color="error" iconOnly={true} onClick={() => handleDeleteItem(currentBlogData)}>
            <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" onClick={() => handleDeleteItem(currentBlogData)}>
                delete
            </Icon>
        </SoftButton>
    </>;
}
Actions.defaultProps = {
    currentBlogData: {},
    handleEditItem: () => { },
    handleDeleteItem: () => { },
};
Actions.propTypes = {
    currentBlogData: PropTypes.object.isRequired,
    handleEditItem: PropTypes.func.isRequired,
    handleDeleteItem: PropTypes.func.isRequired,
};
function blogBlogListing(categoryData, handleEditItem, handleDeleteItem, addEditBlog) {
    return {
        columns: [
            {
                colummKey: "title",
                name: "Title",
                align: "left",
                width: '300px'
            },
            {
                colummKey: "slug",
                name: "Slug",
                align: "left",
                width: '150px'
            },
            {
                colummKey: "publish_date",
                name: "Publish Date",
                align: "center",
                width: '75px'
            },
            {
                colummKey: "seoStatus",
                name: "Seo Status",
                align: "center",
                width: '100px'
            },
            {
                colummKey: "status",
                name: "Status",
                align: "center",
                width: '25px'
            },
            {
                colummKey: "action",
                name: "Action",
                align: "center",
                width: '100px'
            },
        ],

        rows: categoryData ? categoryData.map((singleBlog) => {
            return {
                title: <Title
                    title={singleBlog.title}
                    image={singleBlog.image}
                    subTitle={
                        singleBlog.category_name !== '' && singleBlog.category_name !== null ?
                            'Category : ' + singleBlog.category_name :
                            ''
                    } />,
                slug: <Slug
                    job={singleBlog.slug} />,
                seoStatus: (
                    <SoftBadge
                        variant="gradient"
                        badgeContent={
                            singleBlog.seo_status === 1 ?
                                'Active' :
                                'Deactive'
                        }
                        color={
                            singleBlog.seo_status === 1 ?
                                'success' :
                                'secondary'
                        }
                        size="md"
                        container />
                ),
                publish_date: (
                    <SoftBadge
                        variant="gradient"
                        badgeContent={singleBlog.publish_date}
                        color="dark"
                        size="md"
                        container />
                ),
                status: (
                    <Switch
                        color="success"
                        size="md"
                        defaultChecked={singleBlog.status === 1 ? true : false}
                        onChange={(event) => {
                            singleBlog['status'] = event.target.checked ? 1 : 0;
                            addEditBlog(singleBlog);
                        }} />
                ),
                action: (
                    <Actions
                        currentBlogData={singleBlog}
                        handleEditItem={handleEditItem}
                        handleDeleteItem={handleDeleteItem} />
                )
            };
        }) : [],
    };
};

export default blogBlogListing;
